module.exports = __webpack_public_path__ + "img/home_logo.4c8d497.png";